module.exports = __webpack_public_path__ + "files/d08a89d19fbf15e29487fc82989259f2.svg";